import axios from '@fs/zion-axios'

// noinspection JSUnusedGlobalSymbols
export default () => {}

const BASE_ODV_PATH = '/service/dmc/odv'

export async function getOdmiRecords(country, query, page = 0) {
  const response = await axios.post(`${BASE_ODV_PATH}/${country}/individuals?page=${page}`, query)
  return response
}

export async function getOdmiRecordsCount(country, query) {
  const response = await axios.post(`${BASE_ODV_PATH}/${country}/qsize`, query)
  return response
}

export async function getOdmSubmissions(query) {
  const response = await axios.post(`${BASE_ODV_PATH}/submissions`, query)
  return response
}

export async function getOdmPersonIdList(query, page = 0) {
  const response = await axios.post(`${BASE_ODV_PATH}/individuals?page=${page}`, query)
  return response
}

export async function getOdmRecordResultCount(query) {
  const response = await axios.post(`${BASE_ODV_PATH}/qsize`, query)
  return response
}

export async function getOdmPersonDetails(nameId) {
  const response = await axios.get(`${BASE_ODV_PATH}/individuals/${nameId}`)
  return response
}

export async function getOrdinanceTypes(country) {
  const response = await axios.get(`${BASE_ODV_PATH}/${country}/ordinance`)
  return response
}

export async function getEvents(country) {
  const response = await axios.get(`${BASE_ODV_PATH}/${country}/event`)
  return response
}
